import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="Home">
      <header className="Home-header">
        <Link to="/" className="home-logo-link">
          <img 
            src="https://app.soteriamarket.com/banner3.jpeg" 
            alt="Soteria Logo" 
            className="home-logo"
          />
        </Link>
        <h1>Soteria Admin Container Tools</h1>
      </header>
      
      <main className="Home-main">
        <div className="tools-container">
          <div className="tools-grid">
            <Link to="/container-excel-builder" className="tool-card">
              <div className="tool-icon">📊</div>
              <h2>Container Data Tape Builder</h2>
              <p>Build and manage container Excel files</p>
            </Link>

            <Link to="/generate-datatape-from-box-dataroom" className="tool-card">
              <div className="tool-icon tool-icon-sheet" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="5" y="3" width="14" height="18" rx="1" stroke="currentColor" strokeWidth="1.5" />
                  <line x1="8" y1="8" x2="16" y2="8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                  <line x1="8" y1="12" x2="16" y2="12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                  <line x1="8" y1="16" x2="13" y2="16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </div>
              <h2>Generate Datatape From Box Data Room (Single Project)</h2>
              <p>Automatically Build Soteria Data Tape from Data Room only</p>
            </Link>

            <Link to="/data-tape-validator" className="tool-card">
              <div className="tool-icon">✅</div>
              <h2>Data Tape Validator</h2>
              <p>Validate data tape files and ensure compliance</p>
            </Link>
          </div>

          <Link to="/project-inquiry" className="tool-simple-link">
            Project Inquiry
          </Link>
        </div>
      </main>
    </div>
  );
}

export default Home;
